import './App.css';
import Main from './main';
import BntAdha9Slots from './modelFunc/components/Button/BntAdha9Slots';
import BntAdha6Slots from './modelFunc/components/Button/BntAdha6Slots';
import { Box } from '@mui/material';
import ModuleCatalog from './ModuleCatalog';
import React, { useEffect, useState, useRef } from 'react';
import BntAdha14Slots from './modelFunc/components/Button/BntAdha14Slots';
import ReserveNow from './modelFunc/components/Button/ReserveNow';
import { Grid2 } from '@mui/material';
import DownloadDocumentation from './modelFunc/components/Button/DownloadDocumentation';
import '@fontsource/open-sans';
import logo_orion from './Image/logo_orion.png';
import { VersaldhuSkin } from './modelFunc/Versal';
import { PowernomSkin } from './modelFunc/Psu';
import { UsPlusSkin } from './modelFunc/Processor';
import { SupervisorSkin } from './modelFunc/Supervisor';
import { ExpBoardSkin } from './modelFunc/Expansion';
import { Rack6slot } from './Orion_6slotrack';
import { Rack9slot } from './Orion_9slotrack';
import { Rack14slot } from './Orion_14slotrack';
import { ScorpyosSkin } from './modelFunc/Scorpyos';
import { ExpansionIOS } from './modelFunc/IOS_Expansion_LITE';
import { ExpansionHPC } from './modelFunc/HPC_Expansion_LITE';
import { Toaster } from 'react-hot-toast';


const INITIAL_DELIVERY_TIME = '#####';

/**
 * Calculates the estimated delivery time based on the number of selected modules.
 * @param {Array} modules - Array of selected modules.
 * @param {number} baseTime - The base delivery time in months.
 * @returns {number} - The estimated delivery time in months.
 */
const calculateDeliveryTime = (modules, baseTime) => {
  return modules.length > 0 ? Math.round(modules.length * 0.5 + baseTime) : baseTime;
};

const RACK_OPTIONS = {
  "6-slot": Rack6slot,
  "9-slot": Rack9slot,
  "14-slot": Rack14slot
};
/**
 * The main App component that renders the UI for the Orion configuration system.
 * Allows users to select modules and delivery time, and trigger actions like downloading documentation or reserving the configuration.
 * @param {Object} props - Component props.
 * @param {Object} props.module - Available modules for selection.
 * @returns {JSX.Element} - The rendered App component.
 */


function App() {
  const [deliveryTime, setDeliveryTime] = useState(INITIAL_DELIVERY_TIME);
  const [currentRack, setCurrentRack] = useState({
    rackModel: Rack9slot,
    modules: Rack9slot.slots.reduce((acc, slot) => {
      acc[slot] = null
      return acc;
    }, {})
  });
  const [rackType, setRackType] = useState('9-slot');
  const [reset, setReset] = useState(false);
  const footerRef = useRef(null);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === "INIT_DATA") {
        if (event.data?.payload?.analytics === true) {
          if (typeof window.clarity === 'function') {
            window.clarity('consent', true);
          }
        }
      }
    };

    window.addEventListener("message", handleMessage);

    // Tell parent we’re ready
    setTimeout(() => {
      window.parent.postMessage({ type: "IFRAME_READY" }, "*");
    }, 500);

    return () => window.removeEventListener("message", handleMessage);
  }, []);


  useEffect(() => {
    const handleScroll = () => {
      if (!footerRef.current) return;
      const scrollY = window.scrollY || window.pageYOffset;
      footerRef.current.style.transform = `translateY(${scrollY}px)`;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  // Effect to update the delivery time whenever selected modules change
  useEffect(() => {
    setDeliveryTime(calculateDeliveryTime(currentRack.modules || [], INITIAL_DELIVERY_TIME));
  }, [currentRack]);

  const handleRackChange = (type) => {
    const rackModel = RACK_OPTIONS[type];
    if (!rackModel) {
      console.error(`Unknown rack type: ${type}`);
      return;
    }
    setReset(!reset);
    setRackType(type); // keep track of selected
    setCurrentRack({
      rackModel,
      modules: rackModel.slots.reduce((acc, slot) => {
        acc[slot] = null;
        return acc;
      }, {})
    });
  };


  // Available modules list with their respective properties
  const availableModules = [
    { id: 'generic-HPC', name: 'Generic HPC', description: 'Provides power to the rack.', Width_HP: 30.5, slot: 3, func: ExpansionHPC, price: 12000 },
    { id: 'powernom', name: 'Power Supply', description: 'Main server unit.', Width_HP: 30.5, slot: 1, func: PowernomSkin, price: 8000 },
    { id: 'Generic-Ios', name: 'Generic-Ios', description: 'Main server unit.', Width_HP: 30.5, slot: 3, func: ExpansionIOS, price: 800 },
    { id: 'versaldhu', name: 'VERSAL Data Handling Computer', description: 'Main server unit.', Width_HP: 30.5, slot: 3, func: VersaldhuSkin, price: 30000 },
    { id: 'usPlus', name: 'Ultrascale + Computer', description: 'Main server unit.', Width_HP: 30.5, slot: 6, func: UsPlusSkin, price: 30000 },
    { id: 'supervisor', name: 'Onboard Computer Supervisor', description: 'Main server unit.', Width_HP: 30.5, slot: 4, func: SupervisorSkin, price: 10000 },
    { id: 'Generic-4ETH', name: 'Ethernet Expansion Board', description: 'Main server unit.', Width_HP: 30.5, slot: 3, func: ExpBoardSkin, price: 8000 },
    { id: 'scorpyos', name: 'Scorpyos', description: 'scorpyos', Width_HP: 30.5, slot: 3, func: ScorpyosSkin, price: 0 },
  ];

  return (
    <Box className='App'>
      <Toaster position="top-right" reverseOrder={false} />
      {/* Header section with format options */}
      <Box className="header" sx={{ width: 'auto', mb: 0, padding: '12px', ml: '31%' }}>
        <Grid2 container justifyContent="center" alignItems="center" spacing={6}>

          <Grid2 item>
            <BntAdha6Slots
              onClick={() => handleRackChange('6-slot')}
              selected={rackType === '6-slot'}
            />
          </Grid2>
          <Grid2 item>
            <BntAdha9Slots
              onClick={() => handleRackChange('9-slot')}
              selected={rackType === '9-slot'}
            />
          </Grid2>
          <Grid2 item>
            <BntAdha14Slots
              onClick={() => handleRackChange('14-slot')}
              selected={rackType === '14-slot'}
            />
          </Grid2>

          <Grid2> <img className="logo_orion" src={logo_orion} alt="Logo Orion" /></Grid2>
        </Grid2>
      </Box>

      {/* Main layout with module catalog and 3d view */}
      <Grid2 container sx={{ height: 'auto', width: '100%', alignItems: 'flex-start' }}>

        <Grid2 item xs={12} md={3} sx={{ width: '30%' }}>

          <Box sx={{ marginTop: -10.75 }}>

            <ModuleCatalog
              availableModules={availableModules}
              currentRack={currentRack}
              setCurrentRack={setCurrentRack}
              reset={reset}
              setReset={setReset}
            />
          </Box>
        </Grid2>

        <Grid2 item xs={12} md={9} sx={{ height: '96vh', width: '40%' }}>
          <Box className="Main" sx={{ height: '100%' }}>
            <Main selectedModules={currentRack} />
          </Box>
        </Grid2>
      </Grid2>


      {/* Footer with price, delivery time, and buttons */}
      <Box
        ref={footerRef}
        sx={{
          height: '7.5vh',
          position: 'fixed',
          bottom: 0,
          width: '97%',
          ml: '0.25%',
          mb: '0.25%',
          background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(20,63,83,1) 50%, rgba(43,140,185,1) 98%)',
          borderRadius: '12px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          boxShadow: '0px -2px 5px rgba(0, 0, 0, 0.2)',
          overflow: 'visible',

          '@media (width:1280px) and (height:800px)': {
            width: '96%',
            ml: '0.25%',
            mb: '0.25%',
            height: '9vh',
            borderRadius: '8px',
          },

          '@media (max-width:1280px)': {
            width: '96.5%',
            ml: '0.25%',
            mb: '0.25%',
            fontSize: '16px',
            height: '8vh',
          },
        }}
      >



        <Box style={{ display: 'flex', alignItems: 'center', marginRight: 'auto', marginLeft: '5%', fontFamily: 'Open Sans', fontSize: '18px' }}>
          <DownloadDocumentation selectedModules={currentRack} deliveryTime={deliveryTime} />
        </Box>

        {Object.values(currentRack.modules).some(m => m !== null) && (
          <Box style={{ textAlign: 'center', flex: 1 }}>
            <h2 style={{ margin: 0, fontFamily: 'Open Sans', fontSize: '18px', color: 'white', textShadow: '0px 1px 1px #23430C' }}>
              Estimated delivery time:
              <span style={{ filter: 'blur(5px)', color: 'rgba(255,255,255,0.8)', fontWeight: 'bold' }}> {deliveryTime}  </span>
            </h2>
            <h2 style={{ margin: 0, fontFamily: 'Open Sans', fontSize: '18px', color: 'white', textShadow: '0px 1px 1px #23430C' }}>
              Estimated Price:
              <span style={{ filter: 'blur(5px)', color: 'rgba(255,255,255,0.8)', fontWeight: 'bold' }}> {deliveryTime}  </span>
            </h2>
          </Box>
        )}

        <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '3%' }}>
          <ReserveNow selectedModules={currentRack} deliveryTime={deliveryTime} />
        </Box>
      </Box>
    </Box>
  );
}

export default App;
